export { default as Header } from './header.vue';
export { default as Bottom } from './bottom.vue';

export function baseUrl() {
  // 通过计算属性返回全局变量
  return this.$baseURL;
}
